import bodybuilder from 'bodybuilder'
import * as Form from '../../../components/form'
import * as Elasticsearch from '../../../elasticsearch'
import * as ReportUtils from '../utils'
import * as Constants from './constants'
import * as Types from './types'

export const fetchTopSourceSendFunction = (event: string) =>
    (community: string, topSources: Types.State) =>
  Elasticsearch.createEsSearch(event)(
    community,
    Elasticsearch.Indexes.TopClicks.MessageRunDetails,
    bodybuilder().size(0)
    .filter(
      'term',
      Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.Community),
      community)
    .query(
      'range',
      Elasticsearch.DocumentFieldNames.MessageSendDate,
      ReportUtils.searchDateRange(topSources.form))
    .query(
      'terms',
      Elasticsearch.keyword(topSources.form.fields.type),
      topSources.data.map((s: Types.TopSource) => s.sourceName),
    ).aggregation(
      'terms',
      Elasticsearch.keyword(topSources.form.fields.type),
      {
        size: topSources.data.length,
      },
      Elasticsearch.DocumentFieldNames.SourceName,
      (uniquePosts: any) => uniquePosts.aggregation(
        'cardinality',
        Elasticsearch.DocumentFieldNames.Id,
        Elasticsearch.AggFieldNames.UniqueCount))
    .build(),
  )

export const fetchTopSourcesFunction = (event: string, max: number) =>
    (community: string, topSources: Types.State) =>
  Elasticsearch.createEsSearch(event)(
    community,
    Elasticsearch.Indexes.TopClicks.EmailActions,
    bodybuilder().size(0)
    .filter(
      'term',
      Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.EventName),
      'click')
    .filter(
      'term',
      Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.Community),
      community)
    .filter(
      'term',
      Elasticsearch.DocumentFieldNames.IncludeInReports,
      true)
    .filter(
      'exists',
      Elasticsearch.DocumentFieldNames.PostSubscriptionId)
    .query(
      'range',
      Elasticsearch.DocumentFieldNames.MessageSendDate,
      ReportUtils.searchDateRange(topSources.form),
    ).aggregation(
      'terms',
      Elasticsearch.keyword(topSources.form.fields.type),
      {
        size: max,
      },
      Elasticsearch.DocumentFieldNames.SourceName,
      (uniquePosts: any) => uniquePosts.aggregation(
        'cardinality',
        Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.CommunityPersonGuid),
        Elasticsearch.AggFieldNames.UniqueCount,
      ).aggregation(
        'terms',
        Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.PostType),
        Elasticsearch.DocumentFieldNames.PostType,
        (uniquePostTypes: any) => uniquePostTypes.aggregation(
          'cardinality',
          Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.CommunityPersonGuid),
          Elasticsearch.AggFieldNames.UniqueCount,
        ),
      ),
    )
    .build(),
  )

export const fetchTopSources =
  fetchTopSourcesFunction(Constants.FETCH_TOP_SOURCES, Constants.NUM_TOP_SOURCES)
export const fetchTopSourceSends =
  fetchTopSourceSendFunction(Constants.FETCH_TOP_SOURCE_SENDS)

export const FormActions = Form.createActionsMap(Constants.TOP_SOURCES_FILTER)



// WEBPACK FOOTER //
// ./src/pages/reports/top-sources/actions.ts